import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import { Typography } from "@mui/material";
import facebook from "../../assets/images/icons/Facebook_logo.svg";

const Footer = () => {
    return (
        <div className="footer-outer-wrapper">
        <div className="footer-wrapper">
            <div className="container">
                <div className="footer">
                    {/* <div className="row d-flex justify-content-center justify-content-md-between align-items-center">
                        <div className="col-auto">
                            <div className="footer-left-part">
                                <img src={footerLogo} alt="footerLogo" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-auto my-1">
                            <div className="footer-right-part d-flex align-items-center">
                                <div className="me-2">
                                    <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px' }}>
                                        Customer Support
                                    </Typography>
                                </div>
                                <div className="me-2">
                                    <Typography variant="body2" sx={{ color: '#B7A577', fontSize: '14px', fontWeight: 700 }}>
                                        FOLLOW US
                                    </Typography>
                                </div>
                                <div>
                                    <FacebookRoundedIcon sx={{ color: '#FFFFFF', marginInline: '4px' }} />
                                    <TwitterIcon sx={{ color: '#FFFFFF', marginInline: '4px' }} />
                                    <InstagramIcon sx={{ color: '#FFFFFF', marginInline: '4px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row my-1">
                        <hr className="border border-light-subtle my-2" />
                    </div>
                    <div className="d-flex flex-wrap justify-content-center text-white g-2">
                        <span className="my-2 text-center">
                            © White Dog Trading Post. All rights reserved.
                        </span>
                        <span className="d-inline-flex flex-wrap justify-content-center my-1">
                            <span className="text-nowrap mx-2 my-1">Terms</span>
                            <span className="text-nowrap mx-2 my-1">Privacy</span>
                            <span className="text-nowrap mx-2 my-1">Cookie Policy</span>
                            <span className="text-nowrap mx-2 my-1">Accessibility Statement</span>
                        </span>
                    </div> */}
                    <div className="row d-flex justify-content-center justify-content-xl-between align-items-center">
                        {/* <div className="col-auto">
                            <div className="footer-left-part">
                                <img src={footerLogo} alt="footerLogo" className="img-fluid" />
                            </div>
                        </div> */}
                        <div className="col-auto my-1 me-1 me-lg-5 me-xl-1">
                            <div className="footer-right-part d-flex align-items-center flex-wrap justify-content-center">
                                <span className="text-nowrap me-2 my-1">
                                    <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px', fontWeight: "400" }} component="a" href="https://whitedogllc.com/" target="_blank" rel="noopener noreferrer">
                                    Home
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 my-1">
                                    <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px', fontWeight: "400" }}>
                                    Terms & Condition
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 my-1">
                                    <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px', fontWeight: "400" }}>
                                    Privacy Policy
                                    </Typography>
                                </span>
                                <span className="text-nowrap mx-2 my-1">
                                    <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px', fontWeight: "400" }}>
                                    Accessibility Statement
                                    </Typography>
                                </span>
                            </div>
                        </div>
                        <div className="col-auto my-1 ms-1 ms-lg-5 ms-xl-1">
                            <span className="my-2 text-center text-white">
                                <Typography variant="body2" sx={{ color: '#FFF', fontSize: '14px', fontWeight: "400" }}>
                                © White Dog Trading Post. All rights reserved. 
                                </Typography>
                            </span>
                        </div>
                        <div className="col-auto my-1">
                            <div className="footer-right-part d-flex align-items-center">
                                <div className="me-2">
                                    <Typography variant="body2" sx={{ color: '#B7A577', fontSize: '14px', fontWeight: 700 }}>
                                        FOLLOW US
                                    </Typography>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <a href="https://www.facebook.com/wdtsllc" target="_blank" rel="noopener noreferrer"><span style={{backgroundColor: '#FFFFFF', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <img src={facebook} alt="footerLogo" height={25}/></span></a>
                                    <span style={{backgroundColor: '#FFFFFF', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <XIcon sx={{ color:"#343330", marginInline: '4px' }} /></span>
                                    <a href="https://www.instagram.com/whitedogtradingandstorage/" target="_blank" rel="noopener noreferrer"><span style={{backgroundColor: '#FFFFFF', borderRadius:"50%", padding:"2px", height:"35px", width:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}> <InstagramIcon sx={{ color:"#343330", marginInline: '4px' }} /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row my-1">
                        <hr className="border border-light-subtle my-2" />
                    </div> */}
                    {/* <div className="d-flex flex-wrap justify-content-center text-white g-2">
                        <span className="my-2 text-center">
                            © White Dog Trading Post. All rights reserved.
                        </span>
                        <span className="d-inline-flex flex-wrap justify-content-center my-1">
                            <span className="text-nowrap mx-2 my-1">Terms</span>
                            <span className="text-nowrap mx-2 my-1">Privacy</span>
                            <span className="text-nowrap mx-2 my-1">Cookie Policy</span>
                            <span className="text-nowrap mx-2 my-1">Accessibility Statement</span>
                        </span>
                    </div> */}
                </div>
            </div>
        </div>
        </div>
    )
}

export default Footer